import Vue from "vue";
import VueRouter from "vue-router";
// import * as firebase from "firebase";

Vue.use(VueRouter);

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: loadView("Homepage"),
    meta: {
      guest: true
    }
  },
  {
    path: "/search",
    name: "SearchView",
    component: loadView("SearchView"),
    meta: {
      guest: true
    }
  },
  {
    path: "/bien/:id",
    props: true,
    name: "Bien",
    component: loadView("ContentView"),
    meta: {
      guest: true
    }
  },
  {
    path: "/proprietaire",
    name: "Proprietaire",
    component: loadView("ProprietaireView"),
    meta: {
      guest: true
    }
  },
  {
    path: "/connection",
    name: "Connection",
    component: loadView("Connection"),
    meta: {
      guest: true
    }
  },
  {
    path: "/inscription",
    name: "Inscription",
    component: loadView("Inscription"),
    meta: {
      guest: true
    }
  },
  {
    path: "/addbien",
    name: "AddBien",
    component: loadView("AddBien"),
    meta: {
      guest: true
    }
  },
  {
    path: "*",
    name: "NotFound",
    component: loadView("NotFound"),
    meta: {
      guest: true
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
